import {Box, Select, Stack, TextField} from '@wellstone-solutions/web';
import {
  ChecklistSection,
  halfWidthSx,
  toSelectItems,
  useNoteForm,
} from '../../NoteForm';
import type {ChangeStatus} from '../choices';
import {CHANGE_STATUSES, STATUS_NEEDS} from '../choices';
import type {ContactNoteAction, ContactNoteState} from '../state';

export const MemberStatusSection = () => {
  const {state, dispatch} = useNoteForm<ContactNoteState, ContactNoteAction>();

  return (
    <Stack spacing={2}>
      <Box sx={halfWidthSx}>
        <Select
          label="Change since last note"
          items={toSelectItems(CHANGE_STATUSES)}
          value={state.changeStatus ?? ''}
          canUnselect={false}
          containerProps={{required: true, fullWidth: true}}
          onChange={(event) =>
            dispatch({
              type: 'set',
              field: 'changeStatus',
              value: event.target.value as ChangeStatus,
            })
          }
        />
      </Box>
      <ChecklistSection
        label="Identified need"
        options={STATUS_NEEDS}
        value={state.needs}
        onToggle={(key) => dispatch({type: 'toggle', field: 'needs', key})}
        onOtherChange={(value) =>
          dispatch({type: 'setOther', field: 'needs', value})
        }
      />
      <TextField
        multiline
        minRows={2}
        label="Describe relevant change"
        value={state.relevantChange}
        onChange={(event) =>
          dispatch({
            type: 'set',
            field: 'relevantChange',
            value: event.target.value,
          })
        }
      />
      <TextField
        multiline
        minRows={2}
        label="Objective observation / member report"
        value={state.observation}
        onChange={(event) =>
          dispatch({
            type: 'set',
            field: 'observation',
            value: event.target.value,
          })
        }
      />
    </Stack>
  );
};
